
// Station dots along the route line
export const STATION_DOT_HEIGHT = '10px';
// The route line
export const ROUTE_LINE_HEIGHT = '4px';
